var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgForum = function SvgForum(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.667 12.465a.65.65 0 0 1-.475-.192.65.65 0 0 1-.192-.475v-1.333h8.667v-6H14q.284 0 .475.191a.65.65 0 0 1 .192.475v8.384q0 .45-.409.625-.408.175-.724-.142L12 12.465zM4 9.13l-1.533 1.534q-.317.316-.725.141-.409-.174-.409-.625V2.465q0-.284.192-.475A.65.65 0 0 1 2 1.798h8.667q.283 0 .475.192a.65.65 0 0 1 .192.475v6a.65.65 0 0 1-.192.475.65.65 0 0 1-.475.191zm6-1.333V3.131H2.667v4.667z"
  })));
};
export default SvgForum;